export default "__VITE_ASSET__e8ba8ddf__"